import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { i18n } from './locales';
import './main.css';
import router from './router';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(i18n);

// Initialisation de l'authentification après la création de Pinia
const initializeAuth = async (): Promise<void> => {
  const { useAuthStore } = await import('./stores/auth');
  const authStore = useAuthStore();
  
  // Initialiser depuis le localStorage (inclut déjà fetchCurrentUser si token valide)
  await authStore.initializeFromStorage();
  
  // Configurer les intercepteurs API
  authStore.setupApiInterceptors();
};

// Initialiser l'authentification avant le montage
initializeAuth().then(() => {
  app.mount('#app');
}).catch((error) => {
  console.error('Erreur lors de l\'initialisation de l\'authentification:', error);
  // Monter l'application même en cas d'erreur d'initialisation
  app.mount('#app');
});

router.beforeEach((to, from, next) => {
  document.title = to.name as string || 'Anamnesis';
  next();
});
